import React                    from 'react';
import { Observe }              from 'rewire-core';
import {
  WithStyle,
  FormView
}                               from 'rewire-ui';
import { Theme }                from '@material-ui/core/styles';
import DraggableResizableDialog from '../ui/DraggableResizableDialog';
import renameGroupDialogModel   from './RenameGroupDialogModel';
import { withStyles }           from '../utility/styles';


const styles = (_theme: Theme) => ({
});

interface IRenameGroupDialogProps {
}

type RenameGroupDialogProps = WithStyle<ReturnType<typeof styles>, IRenameGroupDialogProps>;

class RenameGroupDialog extends React.PureComponent<RenameGroupDialogProps> {
  constructor(props: RenameGroupDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    renameGroupDialogModel.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={renameGroupDialogModel.form} onSubmit={renameGroupDialogModel.actionFn('save')}>
        <div className='content'>
          <renameGroupDialogModel.form.field.name.Editor className='span1' />
        </div>
      </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: renameGroupDialogModel}} DraggableResizableBoxProps={{minWidth: '250px', minHeight: '213px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IRenameGroupDialogProps>(styles, RenameGroupDialog);
